(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-rozatoare"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.prReady) return;
    root.dataset.prReady = 'true';
    const strings = JSON.parse(root.querySelector('[data-pr-strings]').textContent);
    const form = root.querySelector('.pr-form');
    const cta = form.querySelector('.pr-cta');
    const radios = [...form.querySelectorAll('input[name="pr_offer"]')];
    const variantInput = form.querySelector('[data-pr-variant]');
    const money = value => new Intl.NumberFormat('ro-RO', {minimumFractionDigits:2, maximumFractionDigits:2}).format(Number(value)/100) + ' lei';
    const update = () => {
      const chosen = form.querySelector('input[name="pr_offer"]:checked');
      if (!chosen) { cta.disabled = true; return; }
      if (variantInput.value !== chosen.value) {
        variantInput.value = chosen.value;
        variantInput.dispatchEvent(new Event('change', {bubbles:true}));
      }
      const price = Number(chosen.dataset.price), shipping = Number(chosen.dataset.shipping);
      root.querySelector('[data-pr-price]').textContent = money(price);
      root.querySelector('[data-pr-shipping]').textContent = shipping === 0 ? strings.free : money(shipping);
      root.querySelector('[data-pr-total]').textContent = money(price + shipping);
      root.querySelector('[data-pr-sticky-total]').textContent = money(price + shipping);
      root.querySelector('[data-pr-sticky-title]').textContent = chosen.dataset.large === 'true' ? strings.large : strings.small;
      const isLarge = chosen.dataset.large === 'true';
      const heroLarge = root.querySelector('[data-pr-hero-large]');
      if (heroLarge) {
        heroLarge.hidden = !isLarge;
        root.querySelector('[data-pr-hero-small]').hidden = isLarge;
      }
      root.querySelector('[data-pr-photo-badge]').textContent = isLarge ? strings.large : strings.small;
      cta.disabled = chosen.disabled;
      root.querySelector('[data-pr-cta]').textContent = chosen.disabled ? strings.unavailable : strings.cta;
    };
    radios.forEach(input => input.addEventListener('change', () => {
      update();
      const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState({}, '', url);
    }));
    root.querySelectorAll('[data-pr-select-large]').forEach(link => link.addEventListener('click', () => {
      const large = radios.find(input => input.dataset.large === 'true');
      if (large && !large.disabled) { large.checked = true; large.dispatchEvent(new Event('change', {bubbles:true})); }
    }));
    form.addEventListener('submit', event => event.preventDefault());
    cta.addEventListener('click', async event => {
      event.preventDefault();
      const chosen = form.querySelector('input[name="pr_offer"]:checked');
      if (!chosen || chosen.disabled || cta.disabled) return;
      const error = root.querySelector('[data-pr-error]'); error.hidden = true;
      cta.disabled = true; root.querySelector('[data-pr-cta]').textContent = strings.loading;
      try {
        variantInput.value = chosen.value;
        variantInput.dispatchEvent(new Event('change', {bubbles:true}));
        const trigger = await new Promise((resolve, reject) => {
          const existing = root.querySelector('#rsi_buy_now_button');
          if (existing) { resolve(existing); return; }
          const observer = new MutationObserver(() => {
            const button = root.querySelector('#rsi_buy_now_button');
            if (button) { observer.disconnect(); clearTimeout(timer); resolve(button); }
          });
          const timer = setTimeout(() => { observer.disconnect(); reject(new Error(strings.error)); }, 5000);
          observer.observe(root, {childList:true, subtree:true});
        });
        trigger.click();
      } catch (e) {
        error.textContent = strings.error; error.hidden = false;
      } finally {
        cta.disabled = false; update();
      }
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('[data-pr-animation]').forEach(figure => {
      const img = figure.querySelector('img'), button = figure.querySelector('button');
      const pause = () => { img.src = img.dataset.static; button.textContent = strings.replay; button.setAttribute('aria-pressed','true'); };
      if (reduced.matches) pause();
      button.addEventListener('click', () => {
        if (button.getAttribute('aria-pressed') === 'true') { const url = new URL(img.dataset.gif, location.href); url.searchParams.set('replay', Date.now()); img.src = url.href; button.textContent = strings.pause; button.setAttribute('aria-pressed','false'); }
        else pause();
      });
      reduced.addEventListener('change', e => { if(e.matches) pause(); });
    });
    update();
  };
  document.querySelectorAll('[data-pr-product]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-pr-product]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
